export class CreateResponseBase{
    public id :number = 0;
}